"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Alert = _interopRequireDefault(require("reactstrap/lib/Alert"));

var _utils = require("../lib/utils");

require("./alert.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Alert component can be used to notify user about some state
 * It could be success, warning or error
 * Optionally an alert component can be closable
 * Ideally, critical alerts should not be closable so that they can grab user's attention.
 */
var Alert = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Alert, _Component);

  var _super = _createSuper(Alert);

  function Alert(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Alert);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCloseClick", function () {
      var _this$props = _this.props,
          closable = _this$props.closable,
          onClose = _this$props.onClose;

      _this.setState({
        isOpen: false
      }, function () {
        if (closable && (0, _utils.isFunction)(onClose)) {
          onClose();
        }
      });
    });
    _this.state = {
      isOpen: true
    };
    return _this;
  }

  (0, _createClass2["default"])(Alert, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          dataTestId = _this$props2.dataTestId,
          type = _this$props2.type,
          closable = _this$props2.closable,
          message = _this$props2.message;
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        "data-testid": dataTestId,
        className: (0, _utils.gatherClasses)(this.props),
        color: type,
        isOpen: isOpen,
        toggle: closable ? this.onCloseClick : null
      }, message);
    }
  }]);
  return Alert;
}(_react.Component);

Alert.propTypes = {
  /**
   * message: the text to be shown under the Alert
   * message is the mandatory property
   */
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]).isRequired,

  /**
   * type: type of the Alert. Any one from the given list
   * default type is success
   */
  type: _propTypes["default"].oneOf(["success", "warning", "danger", "info"]),

  /**
   * closable: a flag to specify if an alert is closable or not
   * by default it is false
   */
  closable: _propTypes["default"].bool,

  /**
   * onClose: a callback function to notify that the alert is being closed
   * applicable only if alert is closable
   */
  onClose: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string
};
Alert.defaultProps = {
  type: "danger",
  closable: false,
  dataTestId: "orion-alert"
};
Alert.displayName = "OrionAlert";
var _default = Alert;
exports["default"] = _default;